// Nguồn duy nhất cho maintenance React-Query keys. KHÔNG import gì khác (tránh circular).
export const MAINTENANCE_PROJECTS_KEY = 'maintenance-projects-v2' as const;
export const MAINTENANCE_STATS_KEY = 'maintenance-stats' as const;
